import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import './PinchZoomSuperWrapper.scss';
import './PinchZoomSuperWrapper.css';
import stat from '../../utils/stat';

// 这个是用来做出了PinchZoom之外的其他功能的
// 目前有一个单指上滑 的功能

// 考虑增加图片长按的识别 2019-12-17 zihan

@observer
class PinchZoomSuperWrapper extends React.Component {
  longPressTimer = 0;

  @observable y = 0;
  @observable start = {
    pageX: 0,
    pageY: 0,
  };
  @observable current = {
    pageX: 0,
    pageY: 0,
  };
  @action touchStart = (e) => {
    clearTimeout(this.longPressTimer);
    // console.log('touch start', e.touches);
    const touch0 = e.touches[0];
    // fundebug:防止报错
    if (typeof touch0 === 'object' && touch0) {
      const { pageX, pageY } = touch0;
      this.start = this.current = { pageX, pageY };

      if (e.touches.length == 1) {
        this.longPressTimer = setTimeout(() => {
          if (this.props.onLongPress) {
            this.props.onLongPress();
          }
        }, 900);
      }
    }
  };
  @computed get distance() {
    const { start, current } = this;
    return {
      x: current.pageX - start.pageX,
      y: current.pageY - start.pageY,
    };
  }
  @computed get scale() {
    // return 1;
    const { clientHeight = 480 } = document.documentElement;
    return Math.abs((clientHeight - Math.abs(this.distance.y)) / clientHeight);
  }
  @action touchMove = (e) => {
    clearTimeout(this.longPressTimer);

    if (e && e.touches && e.touches.length) {
      const touch0 = e.touches[0];
      if (touch0) {
        const { pageX, pageY } = touch0;
        //最小启动的滑动距离
        if (Math.abs(pageY - this.start.pageY) < 100) {
          return;
        }

        // 得需要判断一下
        // 如果X的变化大于Y的变化，则只更新X值
        let offsetX = Math.abs(pageX - this.start.pageX);
        let offsetY = Math.abs(pageY - this.start.pageY);
        if (offsetX < offsetY && offsetX < 60) {
          this.current = {
            ...this.current,
            pageY: pageY,
          };
          return;
        } else {
          this.current = {
            ...this.current,
            pageX: pageX,
          };
          return;
        }
      } else {
        console.log('ops, no touch0 here', touch0);
      }
    } else {
      console.log('ops, touch move has sth wrong with e', e);
    }
  };
  //注意，不知道为什么pz_dragend阻止掉之后还是会触发这里的touchend
  @action touchEnd = () => {
    clearTimeout(this.longPressTimer);
    //只有大于Xpx的移动认为是有效的，否则无视掉
    const MAX = 245;
    const { y } = this.distance;
    // console.log('end', y);
    if (Math.abs(this.distance.y) >= MAX) {
      //这儿是下滑关闭操作
      stat.event('swiper_down');
      this.props.hideBigPic && this.props.hideBigPic();
    } else {
      //如果移动幅度小，直接还原回来
      // 注意，因为部分安卓机可能在双击时不会触发第二次的touchStart(不知道为什么会这样)
      // 所以重新赋值时不能初始化成{pageX:0,pageY:0}，否则最终会发现distance.y大过了MAX
      // 最终导致双击的效果变成了关闭
      this.current = this.start;
    }
  };

  componentWillUnmount() {
    clearTimeout(this.longPressTimer);
  }

  render() {
    return (
      <div
        className="w-wrapper"
        style={{
          transform: `scale(${this.scale}) translate(0,${this.distance.y}px)`,
        }}
        onTouchMove={this.touchMove}
        onTouchEnd={this.touchEnd}
        onTouchStart={this.touchStart}
      >
        {this.props.children}
      </div>
    );
  }
}

export default PinchZoomSuperWrapper;
